import { render, staticRenderFns } from "./RemoteVideo.vue?vue&type=template&id=519c9760&scoped=true"
import script from "./RemoteVideo.vue?vue&type=script&lang=js"
export * from "./RemoteVideo.vue?vue&type=script&lang=js"
import style0 from "./RemoteVideo.vue?vue&type=style&index=0&id=519c9760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519c9760",
  null
  
)

export default component.exports